// packages/hooks/useProducts.ts
import { useState, useEffect } from "react";
import { useData } from "../core/useData";
import { QueryFilters } from "../../types/core/BaseService";
import { Product } from "../../types/Product";
import { productService } from "../../services/productService";

export function useProducts(initialFilters?: QueryFilters) {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(10); // Nombre d'éléments par page

    // 1. On utilise le hook générique pour le gros du travail
    const {
        data: products,
        total,
        pages,
        loading,
        error,
        count,
        refresh,
        deleteItem,
        updateItem,
        deleteManyItems
    } = useData<Product>({
        ...productService,
        ...productService.baseService
    }, {
        ...initialFilters,
        page: currentPage,
        limit
    });

    // Fonction pour changer de page
    const goToPage = (page: number) => {
        if (page >= 1 && page <= pages) {
            setCurrentPage(page);
        }
    };

    // Fonction pour la page suivante
    const nextPage = () => {
        if (currentPage < pages) {
            setCurrentPage(currentPage + 1);
        }
    };

    // Fonction pour la page précédente
    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Rafraîchir les données en restant sur la page courante
    const refreshCurrentPage = () => {
        refresh();
    };

    return {
        products,
        loading,
        error,
        total,
        pages,
        currentPage,
        limit,
        goToPage,
        nextPage,
        prevPage,
        count,
        refresh: refreshCurrentPage,
        deleteProduct: deleteItem,
        updateProduct: updateItem,
        deleteManyProducts: deleteManyItems
    };
}